/**
 * Helpers for the admin-approved Pixabay image shared per Google place.
 *
 * Kept free of Vue so it can be unit tested with plain node
 * (tests/unit/sharedPlaceImages.test.js).
 *
 * A pixabayPick is { pixabayId: number, uploadedUrl: string | null }.
 */

/** Keeps [A-Za-z0-9_-]; anything else becomes an underscore. */
function safe(value) {
  return String(value).replace(/[^A-Za-z0-9_-]/g, '_');
}

/**
 * Firebase path for a cropped image. A Pixabay pick on a known place goes to
 * places/ so every ride can reuse it; anything else keeps today's name.
 */
function storagePathForCrop({
  pixabayPick, placeId, ridePrefix, timeStamp,
}) {
  if (pixabayPick && placeId) {
    return `places/${safe(placeId)}_${pixabayPick.pixabayId}_${timeStamp}`;
  }
  return `attractions/${ridePrefix}_${timeStamp}`;
}

/**
 * The record to report to the backend, only when the image that was actually
 * saved is the one the pick uploaded (the user may have swapped it since).
 */
function pickToRecord({ pixabayPick, placeId, savedImageUrl }) {
  if (!pixabayPick || !placeId) return null;
  if (!savedImageUrl || savedImageUrl !== pixabayPick.uploadedUrl) return null;
  return { placeId, imageUrl: savedImageUrl, pixabayImageId: pixabayPick.pixabayId };
}

/** Prefill only a new attraction that has no image yet and a known place. */
function shouldPrefillSharedImage({ isEditMode, currentImage, placeId }) {
  return !isEditMode && !currentImage && !!placeId;
}

/**
 * True when the current image is exactly the one we pre-filled from the shared
 * pool (so it is not a person's choice and must not block another place's image).
 */
function isPrefilledImage({ currentImage, prefilledImage }) {
  return !!currentImage && !!prefilledImage && currentImage === prefilledImage;
}

module.exports = {
  isPrefilledImage,
  storagePathForCrop,
  pickToRecord,
  shouldPrefillSharedImage,
};
